module.exports = __webpack_public_path__ + "static/img/3_1_8_2.83e0ff32.jpg";